import {useEffect} from "react";

const usePagination = (currentPage, totalPages, setDisplayPages, displayPages) => {

    useEffect(() => {
        let visiblePages = [1]; // Always include the first page

        if (currentPage > 4) visiblePages.push('...');

        let middleStart = Math.max(2, currentPage - 2);
        let middleEnd = Math.min(currentPage + 2, totalPages[totalPages.length - 1] - 1);
        for (let i = middleStart; i <= middleEnd; i++) visiblePages.push(i);

        if (currentPage < totalPages[totalPages.length - 1] - 3) visiblePages.push('...');

        if (totalPages.length > 1) visiblePages.push(totalPages[totalPages.length - 1]);

        const modifiedPages = [];
        for (let i = 0; i < visiblePages.length; i++) {
            modifiedPages.push(visiblePages[i]);
            if (i < visiblePages.length - 1 && visiblePages.at(i + 1) - visiblePages.at(i) > 1) {
                modifiedPages.push('...');
            }
        }

        setDisplayPages(modifiedPages);
    }, [currentPage, totalPages]);

}

export default usePagination;